import React from 'react';
import classNames from 'classnames';

import styles from "./styles.module.scss";
import ResultContainer from "../../components/ResultContainer";
import WinSound from "../../../../assets/sounds/win-sound.wav";

const WinPage: React.FC = () => {
  return (
    <div className={classNames(styles.page, "base-page")}>
      <ResultContainer
        isWon={true}
        audioSrc={WinSound}
      />
    </div>
  );
};

export default WinPage;
